import { useState } from 'react';
import { CheckList, Field } from './Shared';

export default function TeamMemberPicker({ employees, teamId, value, onChange }) {
 const [search, setSearch] = useState('');
 const query = search.trim().toLocaleLowerCase();
 const visible = employees.filter(person => `${person.name} ${person.team_name || 'No team yet'}`.toLocaleLowerCase().includes(query));
 return <section className="team-form-section team-member-picker" aria-label="Team members">
  <header className="team-section-heading"><div className="team-member-heading"><h3>Team members</h3><span className="badge blue">{value.length} selected</span></div>
  <p className="caption">Select people to add to this team. Their current team is shown below their name. Moving someone from another team requires confirmation when you save.</p></header>
  {employees.length ? <>
   <Field label="Search employees"><input type="search" className="input full" placeholder="Search by name or team…" value={search} onChange={event=>setSearch(event.target.value)}/></Field>
   <CheckList options={visible.map(person=>({
    id:person.id,
    name:person.name,
    detail:<span className={`badge ${person.team_id ? 'blue' : ''}`}>{person.team_id ? `${teamId && person.team_id===teamId ? 'Current team: ' : 'Team: '}${person.team_name}` : 'No team yet'}</span>,
   }))} value={value} onChange={onChange}/>
   {!visible.length && <p className="note" role="status">No employees match your search.</p>}
  </> : <p className="note">No Schedule Profiles are available for you to select. You can save this team first, then add eligible users in Scheduler Settings → Profiles.</p>}
 </section>;
}
